import React from 'react'

//UI
import { Flex, Text, SimpleGrid } from '@chakra-ui/react'

import { DatePicker, DummyInput, Input } from '@/components/Form'
import { CostBudgetType, SourcingPostType } from '@eapproval/offer-shared'
import { useTranslation } from 'react-i18next'

//Hooks

//Hooks

const VendorUploadGeneralInfoSection = ({ costBudgetType }) => {
  const { t, i18n } = useTranslation()
  return (
    <SimpleGrid columns={4} spacing={'2'}>
      <Input
        label={t('VENDOR_UPLOAD_PAGE_SUBMISSION_DEADLINE')}
        isRequired={false}
        name={'submissionDueDate'}
        isRow
        disabled
      />

      {[CostBudgetType.SUPPLY_SITE_WORK_RFQ, CostBudgetType.SUPPLY_SITE_WORK].includes(costBudgetType) && (
        <>
          <Input label={t('VENDOR_UPLOAD_PAGE_PROJECT_NAME')} name={'projectName'} isRequired={false} isRow disabled />
          <Input label={t('VENDOR_UPLOAD_PAGE_RFQ_SITE')} name="site" isRequired={false} isRow disabled />
        </>
      )}

      {costBudgetType === CostBudgetType.SUPPLY_MATERIAL_ONLY && (
        <DatePicker
          label={t('VENDOR_UPLOAD_PAGE_EXPECTED_DELIVERY_DATE')}
          name="expectedDeliveryDate"
          isRequired={false}
          isRow
          disabled
        />
      )}

      {[CostBudgetType.SUPPLY_SITE_WORK_RFQ, CostBudgetType.SUPPLY_SITE_WORK].includes(costBudgetType) && (
        <Flex gap={2} alignItems={'center'}>
          <DatePicker
            labelWidth="61"
            label={t('VENDOR_UPLOAD_PAGE_TENTATIVE_PROJECT_DURATION')}
            name="expectedDeliveryDate"
            isRequired={false}
            isRow
            disabled
          />
          <Text as="i">To</Text>
          <DatePicker name="projectEndDate" isRequired={false} isRow disabled />
        </Flex>
      )}
    </SimpleGrid>
  )
}

export default VendorUploadGeneralInfoSection
